<script lang="ts">
    import type {BooleanFilterableDatatype, GenericDatatypedFilterDefinition} from '../../types';
    import DatatypeValueEditor from './DatatypeValueEditor.svelte';

    export let valueFilterDefinition: GenericDatatypedFilterDefinition<BooleanFilterableDatatype>;
</script>

<DatatypeValueEditor filterableDatatypeDefinition={valueFilterDefinition}/>
